
import getPromiseCallback from '../../common/client/utils/getPromiseCallback';

export function createProject(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'createProject',
            token: action.token,
            body: {
                params: action.params
            },
            callback: getPromiseCallback(
                resolve, reject
            )
        });
    });
}

export function deleteProject(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'deleteProject',
            token: action.token,
            body: {
                id: action.id
            },
            callback: getPromiseCallback(
                resolve, reject
            )
        });
    });
}

export function getProject(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callGet({
            module: 'project',
            name: `getProject/${action.id}`,
            token: action.token,
            callback: getPromiseCallback(
                resolve, reject
            )
        });
    });
}

export function getProjectList(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callGet({
            module: 'project',
            name: 'getProjectList',
            token: action.token,
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

export function knDataExec(serverApi, action) {
    const {type, ...params} = action;
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'knDataExec',
            token: action.token,
            body: {
                params: params
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

export function setParameter(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: `setParameter`,
            token: action.token,
            body: {
                id: action.id,
                name: action.name,
                value: action.value
            },
            callback: getPromiseCallback(
                resolve, reject
            )
        });
    });
}

